<template>
    <list-page icone="mdi-file-tree-outline" titulo="Plano de Contas Contábil" @novo="Novo()" @atualizar="Listar()" :temBuscaRapida="true" :buscaRapida.sync="search" >
        <template v-slot:corpo>

          <v-data-table id="tabela" :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
            
            <template v-slot:[`item.actions`]="{ item }">

              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                </template>
                <span>Excluir</span>
              </v-tooltip>

            </template>

            <template v-slot:[`item.tipo`]="{ item }">
              {{item.tipoStr}}
            </template>

            <template v-slot:[`item.tipoConta`]="{ item }">
              {{item.tipoContaStr}}
            </template>

          </v-data-table>

          <!-- <v-data-table :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                    <td class="justify-center layout px-0">
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                        </template>
                        <span>Excluir</span>
                      </v-tooltip>
                    </td>
                    <td>{{ item.classificador }}</td>
                    <td>{{ item.nome }}</td>
                    <td>{{ item.tipoStr }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table> -->

          <v-overlay :value="primeiraCarga">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <cadastro-planocontacontabil v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Listar()"/>

        </template>
    </list-page>
</template>
<script>
import PlanoContaContabilService from '@/core/services/financeiro/PlanoContaContabilService';
import PlanoContaContabil from '@/core/domain/financeiro/PlanoContaContabil';
import ListPage from "@/components/shared/ListPage";

export default {
    extends: ListPage,
    data: () => ({
      headers: [
        { text: '', value:'actions', sortable: false  },
        { text: 'Classificador', value: 'classificador' },
        { text: 'Código Reduzido', value: 'codigoReduzido' },
        { text: 'Nome', value: 'nome' },
        { text: 'Natureza', value: 'tipo' },
        { text: 'Tipo da Conta', value: 'tipoConta' }
      ],
      primeiraCarga: true
    }),
    watch:{
      lista: function(){
        if(this.primeiraCarga)
          this.primeiraCarga = false;
      }
    },
    created() {
      this.service = new PlanoContaContabilService();
    },
    methods: {
      Novo(){
        this.NovoCadastro(new PlanoContaContabil());
      },
      Editar(item){
        this.service.ObterPorId(item.id)
          .then(
            res =>{
              this.EditarCadastro(new PlanoContaContabil(res.data));
            },
            err => this.$swal('Aviso', err.response.data, 'error')
          )
      }
    },
    mounted() {
      this.Listar()
    }
}
</script>
<style scoped>

</style>
